import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

interface UpdateCreditsAnchorDayResponse {
  subscription_id: string;
  plan_start: number;
  // Null when the cycle is still owed: the endpoint leaves the markers to the nightly job
  credits_reset_at: number | null;
  credits_period_end: number | null;
}

async function updateCreditsAnchorDay(
  subscriptionId: string,
  day: number,
  auth: Authentication
): Promise<UpdateCreditsAnchorDayResponse> {
  try {
    const response = await HttpClient.post(
      `/backoffice/subscriptions/${subscriptionId}/credits/anchorday`,
      { day },
      auth.token
    );
    return response.data;
  } catch (e: any) {
    console.error('updateCreditsAnchorDay error:', e);
    throw new UpdateCreditsAnchorDayFailure(e.message);
  }
}

export class UpdateCreditsAnchorDayFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default updateCreditsAnchorDay;
